import React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep } from '../../store/formSlice';
import StepHeader from './StepHeader';

const ActivateTrialStep = () => {
    const dispatch = useDispatch();
    const { currentStep, totalSteps } = useSelector((state) => state.form);
    const handleClick = () => {
        dispatch(nextStep())
    }
    return (
        <Box maxW={{ base: '100%', md: '3xl' }} mx="auto" p={{ base: 4, md: 6 }} textAlign="center">
            <StepHeader title="Activate 30-Day Free Trial" subtitle="Enjoy your first 30 days free." />
            <Text fontSize={{ base: '16px', md: '18px' }} color="black" mb={6}>
                Start making a difference today — no commitment, cancel anytime.
            </Text>
            <Button
                mt={4}
                px="30px"
                onClick={handleClick}
            >
                Add Payment Method
            </Button>
        </Box>
    );
};

export default ActivateTrialStep; 